import addresses from 'config/constants/contracts'

import { GRAPH_API_PREDICTION_CAKE, GRAPH_API_PREDICTION_BNB } from 'config/constants/endpoints'
import { getAddress } from 'utils/addressHelpers'
import { baseTestnetTokens, baseTokens, bscTokens } from '@pancakeswap/tokens'
import { BigNumber } from '@ethersproject/bignumber'

const DEFAULT_MIN_PRICE_USD_DISPLAYED = BigNumber.from(1)

export default {
  BNB: {
    address: '0xFBE87Ee1Ee62244A2dF80a8093Eab829C52863e8',
    api: GRAPH_API_PREDICTION_BNB,
    chainlinkOracleAddress: '0x71041dddad3595F9CEd3DcCFBe3D1F4b0a16Bb70',
    minPriceUsdDisplayed: DEFAULT_MIN_PRICE_USD_DISPLAYED,
    displayedDecimals: 4,
    token: baseTokens.eth,
  },
  CAKE: {
    address: '0xFBE87Ee1Ee62244A2dF80a8093Eab829C52863e8',
    api: GRAPH_API_PREDICTION_BNB,
    chainlinkOracleAddress: '0x71041dddad3595F9CEd3DcCFBe3D1F4b0a16Bb70',
    minPriceUsdDisplayed: DEFAULT_MIN_PRICE_USD_DISPLAYED,
    displayedDecimals: 4,
    token: baseTokens.cake,
  },
}
